export const MODULE_NAME = "session";

export const TOKEN_STORAGE_KEY = "cypex-auth-token";

export const LANGUAGE_STORAGE_KEY = "cypex-lang";

export const ANON_ROLE_NAME = "anon";
